run.$inject = ['$rootScope','$templateCache','$state','$stateParams','$timeout','MenuConstant','strategicTracking'];

export default function run($rootScope,$templateCache,$state,$stateParams,$timeout,MenuConstant,strategicTracking) {
  MenuConstant[0]['menu'].push(strategicTracking);
}


// WEBPACK FOOTER //
// ./src/app/u-faculty/strategicTracking/strategicTracking.run.js